export class ConnectorValidationModel {
    // indicates forbidden from - to connections
    // Property indicates from plugin
    // Value is an array of forbidden TO connections
    // example: {"GENERAL_START_PLUGIN": ['GENERAL_END_PLUGIN']}
    forbiddenConnections = {};

    constructor(options) {
        if (options) {
            this.forbiddenConnections = options;
        }
    }
}
